module.exports = __WEBPACK_EXTERNAL_MODULE_141__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Vue","commonjs":"vue","commonjs2":"vue","amd":"vue"}
// module id = 141
// module chunks = 0